// extracted by mini-css-extract-plugin
export default {"comlumnSearchToolTitle":"styles_comlumn-search-tool-title__6NbYE"};